import React from 'react';

const Container = ({ children }) => (
  <div
    style={{
      width: '100%',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      marginTop: '1rem',
    }}
  >
    <div style={{ maxWidth: 936, position: 'relative', width: '100%' }}>
      {children}
    </div>
  </div>
);

Container.propTypes = {};
Container.defaultProps = {};

export default Container



// WEBPACK FOOTER //
// ./src/components/Container/index.js